import styled from 'styled-components'
import { orange, white } from '@/theme/colors'

export const ColumnContainer = styled.div`
	background: ${white};
	border-radius: 12px;
	padding: 16px;
	min-width: 300px;
	max-width: 350px;
	max-height: 100%;
	display: flex;
	flex-direction: column;

	@media (max-width: 600px) {
		min-width: calc(100vw - 24px);
		max-width: calc(100vw - 24px);
		padding: 14px;
	}
`

export const ColumnHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
	padding-bottom: 0.75rem;
	border-bottom: 2px solid #e9ecef;
	flex-shrink: 0;
`

export const ColumnTitle = styled.h2`
	margin: 0;
	font-size: 18px;
	font-weight: 600;
	color: #111827;
`

export const IdeaCount = styled.span`
	background-color: #e5e7eb;
	color: #6b7280;
	padding: 4px 12px;
	border-radius: 12px;
	font-size: 14px;
	font-weight: 500;
`

export const ColumnContent = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	gap: 8px;
`

export const CardsWrapper = styled.div`
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	min-height: 0;

	/* Custom scrollbar styling */
	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: #f8f9fa;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background: #d1d5db;
		border-radius: 3px;

		&:hover {
			background: #9ca3af;
		}
	}

	/* Firefox */
	scrollbar-width: thin;
	scrollbar-color: #d1d5db #f8f9fa;
`

export const AddIdeaButton = styled.button`
	background: ${orange};
	color: white;
	border: none;
	border-radius: 8px;
	padding: 12px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.2s;
	flex-shrink: 0;

	&:hover {
		opacity: 0.9;
	}
`

export const EmptyState = styled.div`
	text-align: center;
	padding: 32px 16px;
	color: black;
	font-size: 14px;
	line-height: 1.6;
`
